import cn from "classnames"
import { ReactMultiEmail } from "react-multi-email"
import "react-multi-email/dist/style.css"
import ConditionalView from "../ConditionalView"
import EmailLabel from "./EmailLabel"

const style = {
  borderRadius: 8,
  backgroundColor: "#f3f7fa",
}

const MultiEmailInput = (props: any) => {
  const emails = props.emails
    ? props.emails?.replaceAll(" ", "")?.split(";")
    : []

  const onChange = (emails: string[]) => {
    const emailText = (emails ?? []).join(";")

    props.onChange({
      target: { value: emailText ? emailText + ";" : "", name: props.name },
    })
  }

  return (
    <div
      className={cn("grid", {
        [props.className]: props.className,
      })}
    >
      <ConditionalView condition={!!props.label}>
        <span className="font-bold text-primary-text mb-1">{props.label}</span>
      </ConditionalView>
      <ReactMultiEmail
        {...props}
        emails={emails}
        placeholder={props.placeholder ?? ""}
        inputClassName=" bg-primary-bg"
        onChange={onChange}
        getLabel={EmailLabel}
        style={{ ...style, ...(props.style ?? {}) }}
        className={cn(
          "bg-gray-100 focus:bg-white focus:outline-none border border-gray-300 overflow-scroll",
          {
            [props.fieldClassName]: props.fieldClassName,
          }
        )}
      />
    </div>
  )
}

export default MultiEmailInput
